import { apiSlice } from "./apiSlice";

export const customerDependenciesSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllDependencies: builder.query({
            query: (params) => ({
                url: `CustomerDependencies`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllDependencies"],
        }),
        addDependency: builder.mutation({
            query: (body) => ({
                url: `CustomerDependencies`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllDependencies']
        }),
        editDependency: builder.mutation({
            query: (body) => ({
                url: `CustomerDependencies`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllDependencies']
        }),

    })
})

export const { useLazyGetAllDependenciesQuery, useAddDependencyMutation, useEditDependencyMutation } = customerDependenciesSlice;